export const en = {
  lang: 'en',
  meta: {
    home: { title: 'EDS Angola — Turnkey Critical Power & Data Centre Engineering | Official Vertiv Partner', desc: 'Turnkey UPS systems, data centre infrastructure and electrical engineering in Angola — design, supply, installation, commissioning and maintenance under one contract. Official Vertiv Authorised Partner and certified Service Provider.' },
    about: { title: 'About EDS Angola | Engineering & Data Solutions, Luanda', desc: 'EDS Angola is an Angolan electrical engineering and data solutions company based in Luanda, delivering turnkey critical power from design to long-term maintenance.' },
    power: { title: 'UPS Systems & Critical Power in Angola | Vertiv UPS 0.7 kVA to 9.6 MW+', desc: 'Vertiv UPS systems, battery plant and power protection in Angola. Sized from a load survey, installed and maintained by certified engineers in Luanda.' },
    dc: { title: 'Data Centre Infrastructure in Angola | Cooling, Containment, Racks & Monitoring', desc: 'Complete data centre white space in Angola — precision cooling, raised flooring, containment, racks, fire suppression and 24/7 monitoring, from design to handover.' },
    ee: { title: 'Electrical Engineering in Angola | Substations, Transformers, Switchgear & Solar', desc: 'MV/LV substations, power transformers, switchgear, ATS/STS, earthing and lightning protection, generators and solar PV — designed, supplied and installed in Angola.' },
    service: { title: 'UPS Maintenance & Service in Angola | Vertiv Certified Service Provider', desc: 'Preventive maintenance contracts, on-site and remote engineer support, repairs and 24/7 cover for critical power systems in Angola. Vertiv-certified Service Provider.' },
    refs: { title: 'Our Clients | EDS Angola Project References', desc: 'Over 100 projects delivered across 13 countries for government, aviation, rail, banking, telecom, data centre, healthcare and industrial clients.' },
    partners: { title: 'Our Partners | Vertiv, Kstar, Fiamm, Netceed & Leoch | EDS Angola', desc: 'EDS Angola delivers genuine factory equipment through direct partnerships with Vertiv, Kstar, Fiamm, Netceed and Leoch.' },
    contact: { title: 'Contact EDS Angola | Luanda', desc: 'Contact EDS Angola in Luanda for critical power, data centre and electrical engineering projects. Rua Emílio Mbidi 74A, Alvalade.' },
  },
  nav: {
    home: 'Home', about: 'About Us', power: 'Critical Power', dc: 'Data Centre',
    ee: 'Engineering', service: 'Service', refs: 'References', partners: 'Partners', contact: 'Contact',
  },
  header: { cta: 'Talk to our team', tagline: 'Vertiv Diamond Partner' },
  home: {
    hero: {
      overline: 'Luanda · Angola — Critical Power Engineering',
      lines: ['Powering Progress.', 'Engineering the Future.'],
      sub: 'EDS Angola delivers turnkey electrical, critical power and data centre solutions — designed, supplied, installed, commissioned and maintained in Angola, under one contract.',
      cert: 'Vertiv Diamond Partner — Authorised Partner and certified Service Provider.',
      btnPrimary: 'Talk to our team',
      btnSecondary: 'See what we deliver',
    },
    trust: [
      { v: '20+', l: 'years of engineering experience' },
      { v: '100+', l: 'large-scale projects delivered' },
      { v: '13', l: 'countries across Africa and the Middle East' },
      { v: 'Vertiv', l: 'Diamond Partner · Authorised & Service Provider' },
    ],
    marquee: ['Survey & Design', 'Supply', 'Civil & Mechanical', 'Installation', 'Commissioning', 'Maintenance'],
    deliver: {
      overline: 'What we deliver',
      title: 'Three disciplines. One accountable party.',
      items: [
        { key: 'power', title: 'Critical Power', body: 'UPS systems, battery plant, backup and power protection — sized from a load survey, engineered to the redundancy your operation needs, installed by our own engineers and maintained afterwards.', link: 'Critical power' },
        { key: 'dc', title: 'Data Centre Infrastructure', body: 'The complete white space: structure, containment, cooling, security and monitoring. One contract, one accountable party, from civil preparation to handover.', link: 'Data centre infrastructure' },
        { key: 'ee', title: 'Electrical Engineering', body: 'Substations, transformers, switchgear, distribution, earthing and solar. The same team that engineers your power protection builds the infrastructure around it.', link: 'Electrical engineering' },
      ],
    },
    manifesto: {
      overline: 'The EDS doctrine',
      title: 'One contract, from first survey to long-term maintenance.',
      p1: 'Most critical power failures are not equipment failures. They happen in the gaps between contractors — where the consultant\u2019s design meets the supplier\u2019s product meets the installer\u2019s workmanship meets nobody\u2019s maintenance. Every one of those handovers is a place responsibility gets lost.',
      p2: 'We remove the handovers. We own the whole chain — one contract, one accountable party, from the first site survey to the fifth year of maintenance.',
      steps: [
        { n: '01', t: 'Survey and design', d: 'Load survey, true power factor measurement, redundancy strategy and full electrical and mechanical design.' },
        { n: '02', t: 'Supply', d: 'Genuine factory equipment through direct manufacturer partnerships — not the grey market.' },
        { n: '03', t: 'Civil and mechanical preparation', d: 'Site works, raised flooring, containment, cooling and structural preparation.' },
        { n: '04', t: 'Installation', d: 'Executed by our own engineers, not subcontracted labour.' },
        { n: '05', t: 'Commissioning and handover', d: 'Tested, documented, and handed over working.' },
        { n: '06', t: 'Maintenance', d: 'Preventive contracts, local spares, Vertiv-certified warranty work in country.' },
      ],
      closing: 'When something goes wrong at three in the morning, there is one number to call and no argument about whose scope it was.',
    },
    why: {
      overline: 'Why EDS Angola',
      title: 'Built to stay responsible.',
      items: [
        { t: 'Factory backed', d: 'Official Vertiv partner. Genuine equipment, full manufacturer warranty, direct factory technical support.' },
        { t: 'Full capability', d: 'Engineering, supply, civil and mechanical works, installation, commissioning and maintenance in house. One contract, not five. Not a reseller.' },
        { t: 'Locally present', d: 'Engineers and spares held in Angola. Technical response without waiting on Europe.' },
        { t: 'Proven', d: 'Over 100 projects delivered for government, banking, telecom, data centre, healthcare and industrial clients.' },
      ],
    },
    cta: {
      title: 'Tell us what you need to protect.',
      body: 'Send us your load, your site, or just the problem you are trying to solve. We will come back with a site visit, a load survey or a budget proposal.',
      btn: 'Contact us',
    },
  },
  about: {
    hero: { overline: 'About EDS Angola', lines: ['Engineering', 'sustainable', 'solutions.'] },
    who: {
      overline: 'Who we are',
      title: 'An Angolan engineering company, built for the long term.',
      p1: 'EDS Angola is an Angolan electrical engineering and data solutions company, based in Luanda, delivering turnkey critical power solutions from design through to long-term maintenance.',
      p2: 'We design, supply, carry out the civil and mechanical works, install, commission and maintain. That full scope is deliberate: the companies that specify a system and the companies that keep it running are usually not the same, and the gap between them is where reliability is lost.',
      p3: 'Our engineering team brings more than 20 years of experience across power, telecommunications and data centre facilities. The group operates in Angola, Lebanon and Iraq, and has delivered over 100 large-scale projects across 13 countries in Africa and the Middle East.',
    },
    differentiators: {
      overline: 'What makes us different',
      items: [
        { t: 'We stay after handover.', d: 'Equipment is the easy part. What protects the investment is what happens in the five years after commissioning — and we are certified by Vertiv to do that work in country.' },
        { t: 'We size properly.', d: 'Systems are engineered from a load survey and true power factor, not from nameplate estimates. Redundancy — N, N+1 or 2N — is specified against what you can afford to lose.' },
        { t: 'We are here.', d: 'Locally based engineers, locally held spares. Not a supplier that flies in.' },
      ],
    },
    vertiv: {
      overline: 'Certified by Vertiv',
      title: 'Two certifications. One covers supply. The other keeps it running.',
      intro: 'EDS Angola is a Vertiv Diamond Partner for Angola, holding two Vertiv certifications:',
      cards: [
        { t: 'Authorised Partner', d: 'We are certified to supply the equipment.' },
        { t: 'Service Provider', d: 'We are certified to maintain it.' },
      ],
      note: 'The second is the one that matters most in practice. It means warranty work and servicing stay in country, across all eight Vertiv solution categories.',
      certLink: { partner: 'Authorised Partner — certificate (PDF)', service: 'Service Provider — certificate (PDF)' },
    },
    mission: {
      t: 'Mission',
      d: 'Engineering sustainable solutions. Our commitment is to power progress in Angola with expert engineering in UPS systems, solar energy and telecommunications infrastructure. Driven by innovation and precision, we work to exceed expectations on every project, shaping a resilient and efficient future.',
    },
    vision: {
      t: 'Vision',
      d: 'At EDS Angola our horizon is global. We aim to be a leading provider of premium, eco-efficient engineering solutions, forging lasting partnerships marked by excellence and trust as we innovate and expand our reach — setting new standards in quality and sustainability.',
    },
    legal: { overline: 'Legal entity' },
  },
  power: {
    hero: {
      overline: 'Critical Power',
      lines: ['UPS systems,', '0.7 kVA to', '9.6 MW+.'],
      sub: 'Vertiv UPS systems, battery plant and power protection in Angola — sized from a load survey, installed and maintained by certified engineers in Luanda.',
    },
    why: {
      overline: 'Why UPS matters',
      items: [
        { t: 'Unstable supply is the leading cause of downtime.', d: 'Grid instability in Angola drives more unplanned outages than equipment failure does.' },
        { t: 'Damage happens long before the lights go out.', d: 'Voltage sags, harmonics and transients degrade equipment continuously and invisibly.' },
        { t: 'A generator is not a substitute.', d: 'A generator covers the outage. Only a UPS covers the transition and the quality of the power itself.' },
        { t: 'The real question is commercial.', d: 'What one hour of downtime costs you, against the cost of protecting the load properly.' },
      ],
    },
    range: {
      overline: 'Vertiv UPS range',
      title: 'One platform from a single rack to multi-megawatt.',
      cols: ['Model', 'Capacity', 'Typical application'],
      rows: [
        ['GXT5', '0.7 – 10 kVA', 'Racks, edge sites, small IT rooms'],
        ['ITA2', '10 – 40 kVA', 'Comms rooms, small facilities'],
        ['EXS', '10 – 80 kVA', 'Commercial buildings'],
        ['EXM2', '100 – 250 kVA', 'Industrial sites, medium data centres'],
        ['Liebert EXL S1', '300 – 1200 kVA', 'Large facilities, monolithic platform'],
        ['PowerUPS 9000', '250 kW – 5 MW', 'Modular, hot-swap, multi-megawatt'],
      ],
      notes: [
        { t: 'Scalable.', d: 'Single units and paralleled systems, with modular capacity that grows with the site — up to and beyond 9.6 MW in a single installation.' },
        { t: 'Battery options.', d: 'VRLA for lower capital cost, lithium-ion for roughly three times the cycle life.' },
        { t: 'Kstar partnership.', d: 'For the 1 – 30 kVA band we also supply Kstar UPS systems — single-phase and three-phase — with the same survey, installation and maintenance scope.' },
      ],
    },
    frames: {
      overline: 'Large-frame systems',
      items: [
        {
          name: 'Vertiv Liebert EXL S1',
          tag: 'The proven monolithic platform',
          bullets: [
            'Transformer-free design',
            'Up to 97% efficiency in double conversion, up to 99% in Dynamic Online mode',
            'Smallest footprint in its class, leaving more room for revenue equipment',
            'Up to eight units in parallel, distributed or centralised',
            'VRLA or lithium-ion battery systems',
          ],
        },
        {
          name: 'Vertiv PowerUPS 9000',
          tag: 'The newest modular platform',
          bullets: [
            '125 kW power modules in a 1250 kW single frame',
            'Up to 97.5% efficiency in double conversion, up to 99% in Dynamic Online mode',
            'Up to 32% space saving against the previous generation',
            'Hot-swap power modules and static bypass — no shutdown to service',
            'VRLA, lithium-ion or nickel-zinc, with skid-mount and containerised options',
          ],
        },
      ],
      note: 'Both platforms parallel to well beyond 9.6 MW in a single installation, and both are sized from a load survey rather than a nameplate figure.',
    },
    batteries: {
      overline: 'Batteries',
      title: 'Autonomy, engineered.',
      body: 'We supply and install industrial battery plant from FIAMM and Leoch — VRLA and lithium-ion — engineered for the autonomy your operation requires, and replaced on a planned cycle rather than on failure.',
    },
    process: {
      overline: 'How we work',
      steps: [
        { n: '01', t: 'Load survey', d: 'We measure what is actually there, including true power factor.' },
        { n: '02', t: 'Sizing and redundancy', d: 'We specify N, N+1 or 2N against the operational risk you carry.' },
        { n: '03', t: 'Supply and installation', d: 'Genuine factory equipment, installed by our own engineers.' },
        { n: '04', t: 'Commissioning', d: 'Tested and handed over, with documentation.' },
        { n: '05', t: 'Maintenance', d: 'Preventive contracts, on-call or 24/7 cover, with local spares.' },
      ],
    },
    cta: 'Request a load survey',
  },
  dc: {
    hero: {
      overline: 'Data Centre Infrastructure',
      lines: ['The complete', 'white space.'],
      sub: 'We build the white space, not just the power train. One contract, one accountable party — from design and civil preparation through to commissioning and handover.',
    },
    integrated: {
      overline: 'Integrated solutions',
      items: [
        { name: 'SmartRow', d: 'A data centre in a row, combining racks, precision cooling, UPS, power management, monitoring and fire suppression in one enclosed system.' },
        { name: 'SmartMod', d: 'Prefabricated modular enclosures, transportable and pre-assembled for rapid deployment.' },
      ],
    },
    bento: {
      overline: 'The build, end to end',
      items: [
        { t: 'Cooling', d: 'Room, in-row, rack and liquid cooling. Free cooling systems that cut energy consumption by up to 50%. Heat rejection and thermal control and monitoring across the facility.' },
        { t: 'Structure', d: 'Raised access flooring — chipboard, calcium sulphate and sintered panel systems. Racks, enclosures and outdoor cabinets. Cold and hot aisle containment.' },
        { t: 'Security and monitoring', d: 'Fire detection and suppression using specialised extinguishing agents. Biometric and card access control, CCTV. 24/7 monitoring and low-current systems.' },
        { t: 'Control room and edge', d: 'Ergonomically designed control room infrastructure and mobile equipment carriers, built for 24-hour mission-critical environments across industrial sectors.' },
      ],
    },
    cta: 'Discuss a data centre project',
  },
  ee: {
    hero: {
      overline: 'Electrical Engineering',
      lines: ['Beyond', 'UPS.'],
      sub: 'The same team that engineers your power protection also builds the electrical infrastructure around it — so the two are designed together rather than bolted together.',
    },
    capabilities: {
      overline: 'Capabilities',
      items: [
        { t: 'Substations and MV/LV distribution', d: 'Design, supply and installation.' },
        { t: 'Power transformers', d: 'Oil-immersed, pad-mounted and custom specification, supplied, installed and commissioned as part of complete substation and MV/LV projects.' },
        { t: 'Switchgear, switchboards and panels', d: 'LV distribution boards and bespoke panel builds.' },
        { t: 'ATS / STS systems', d: 'Automatic and static transfer switching.' },
        { t: 'Earthing, bonding and lightning protection', d: 'Full protective systems designed to international standard.' },
        { t: 'Electrical cabling and distribution', d: 'Cabling, circuit breakers, distribution panels and bonding.' },
        { t: 'Generators and solar PV', d: 'Backup generation and renewable systems — design, installation and maintenance of end-to-end solar power systems for industrial, commercial and residential sites.' },
      ],
    },
    cta: 'Talk to an engineer',
  },
  service: {
    hero: {
      overline: 'Service & Maintenance',
      lines: ['After', 'handover.'],
      sub: 'Equipment is the easy part. What protects the investment is what happens in the five years after commissioning.',
    },
    offerings: {
      overline: 'What we cover',
      items: [
        { t: 'Preventive maintenance contracts', d: 'Quarterly, on-call or 24/7 cover, structured around the criticality of your installation.' },
        { t: 'Remote and on-site engineer support', d: 'Technical response from Luanda, without waiting on Europe.' },
        { t: 'Repair and replacement', d: 'Defective parts fixed or replaced, with spares held locally.' },
        { t: 'One-year warranty', d: 'On all products we supply.' },
        { t: 'Vertiv-certified Service Provider', d: 'Warranty and service work stays in country, across all eight Vertiv solution categories.' },
        { t: 'Locally based engineers and spares', d: 'Present in Angola, not flying in.' },
      ],
    },
    noc: {
      overline: 'Network operations',
      title: '24/7 network operation centre.',
      body: 'NOC capability for data centre monitoring and help desk services.',
    },
    why: {
      overline: 'Why it matters commercially',
      body: 'An unmaintained UPS is a single point of failure that everybody assumes is working. Batteries degrade on a predictable curve; capacitors and fans have finite lives. Planned replacement costs a fraction of an unplanned outage, and it is the only way a manufacturer warranty stays intact.',
    },
    cta: 'Request a maintenance proposal',
  },
  refs: {
    hero: {
      overline: 'References',
      lines: ['Proven across', '13 countries.'],
      sub: 'Over 100 large-scale projects delivered across 13 countries in Africa and the Middle East.',
    },
    track: {
      overline: 'Track record',
      angola: 'In Angola, we have delivered for clients across government, aviation, rail, banking, telecommunications, data centres, healthcare, industry and construction.',
      international: 'Internationally, our group has delivered for government, defence, utilities, telecommunications, United Nations agencies, healthcare, banking and industrial clients across the Middle East and West Africa.',
    },
    wall: {
      overline: 'Our clients',
      sub: 'Organisations we have delivered for in Angola and abroad.',
      groups: [
        { label: 'Angola — Data centres & telecom', clients: ['Raxio', 'Africell'] },
        { label: 'Angola — Government & institutional', clients: ['Tribunal Constitucional', 'Aeroporto', 'Caminho de Ferro de Lobito'] },
        { label: 'Angola — Banking', clients: ['Banco BNI'] },
        { label: 'Angola — Industry & construction', clients: ['Mota-Engil', 'Omatapalo', 'Webcor', 'Castel', 'Grandes Moagens', 'Induve', 'Refitec', 'Zeepack', 'Noble', 'Bom Jesus', 'Dulceria', 'Aroma Verde'] },
        { label: 'Angola — Healthcare', clients: ['Luanda Medical Center'] },
        { label: 'International', clients: ['Ogero', 'touch', 'Terranet', 'Cedarcom', 'Talia', 'UNDP', 'UNRWA', 'Lebanese Red Cross', 'AUBMC', 'Clemenceau Medical Center', 'Nestlé Waters', 'Pfizer', 'Fransabank', 'MEAB', 'Majid Al Futtaim', 'MEA', 'Thi Qar Oil Company'] },
      ],
    },
    countries: {
      overline: 'Countries',
      list: ['Angola', 'Burkina Faso', 'Cameroon', 'Central African Republic', 'Democratic Republic of the Congo', 'Ghana', 'Guinea-Conakry', 'Iraq', 'Lebanon', 'Libya', 'Nigeria', 'Sierra Leone', 'Togo', 'Zambia'],
    },
    sectors: {
      overline: 'Sectors we serve',
      list: ['Government and public institutions', 'Banking and financial services', 'Telecommunications operators', 'Data centre operators', 'Aviation and rail', 'Healthcare', 'Industry and manufacturing', 'Construction and contracting', 'Commercial and residential developments'],
    },
    cta: 'Ask for references in your sector',
  },
  partners: {
    hero: {
      overline: 'Partners',
      lines: ['Genuine equipment.', 'Direct from factory.'],
      sub: 'We supply through direct manufacturer partnerships — not the grey market. Full warranty, factory technical support, certified service in country.',
    },
    overline: 'Technology partners',
    items: [
      { name: 'Vertiv', tag: 'Diamond Partner · Authorised & Service Provider — Angola', d: 'Critical power, thermal management, racks and monitoring. Certified to supply and to maintain, across all eight Vertiv solution categories.' },
      { name: 'Kstar', tag: 'UPS systems 1 – 30 kVA', d: 'Single-phase and three-phase UPS systems from 1 to 30 kVA for racks, edge sites and small facilities — surveyed, installed and maintained by our own engineers.' },
      { name: 'Fiamm', tag: 'Industrial batteries', d: 'Industrial battery systems engineered in Italy — VRLA and lithium-ion plant for UPS and standby power applications.' },
      { name: 'Netceed', tag: 'Network infrastructure', d: 'Network infrastructure and connectivity solutions for telecommunications and data centre environments.' },
      { name: 'Leoch', tag: 'Battery technology', d: 'VRLA and lithium-ion battery technology for critical backup power, supplied and installed with engineered autonomy.' },
    ],
    cta: 'Discuss supply for your project',
  },
  partnerPages: {
    vertiv: {
      name: 'Vertiv',
      meta: { title: 'Vertiv Partner in Angola | Diamond Partner & Service Provider | EDS Angola', desc: 'Vertiv Diamond Partner for Angola — UPS from 0.7 kVA to multi-megawatt, thermal management, racks, power distribution and monitoring, supplied and serviced in country by EDS Angola.' },
      tag: 'Diamond Partner · Authorised & Service Provider — Angola',
      intro: 'Vertiv builds the critical infrastructure behind the world\u2019s data centres and communication networks. As Vertiv Diamond Partner for Angola — Authorised Partner and certified Service Provider — we supply and maintain the full portfolio across all eight solution categories.',
      image: 'serverBlue',
      families: [
        { t: 'AC power & UPS', d: 'Double-conversion UPS from a single rack to multi-megawatt plants.', items: ['GXT5 · 0.7–10 kVA', 'ITA2 · 10–40 kVA', 'EXS · 10–80 kVA', 'EXM2 · 100–250 kVA', 'Liebert EXL S1 · 300–1200 kVA', 'PowerUPS 9000 · 250 kW–5 MW'] },
        { t: 'Thermal management', d: 'Room, in-row, rack and liquid cooling, with free-cooling options that cut energy consumption by up to 50%.', items: ['Room cooling', 'In-row cooling', 'Rack & liquid cooling', 'Free cooling'] },
        { t: 'Racks & containment', d: 'Server racks, enclosures, outdoor cabinets and cold/hot aisle containment.', items: ['Server racks', 'Enclosures & outdoor cabinets', 'Cold & hot aisle containment'] },
        { t: 'Power distribution', d: 'Rack PDUs, busway and static transfer switches for the last metres of the power chain.', items: ['Rack PDUs', 'Busway', 'Static transfer switches'] },
        { t: 'Monitoring & management', d: 'Facility monitoring, sensors and management software for 24/7 visibility.', items: ['Monitoring platforms', 'Sensors', 'Remote management'] },
        { t: 'Integrated & modular', d: 'Pre-engineered data centre systems for rapid deployment.', items: ['SmartRow', 'SmartMod'] },
        { t: 'DC power', d: 'DC power systems for telecommunications networks.', items: ['Telecom DC plant', 'Rectifiers', 'Outdoor DC systems'] },
        { t: 'Services', d: 'As certified Service Provider, warranty and service work stays in country — delivered by our own engineers.', items: ['Warranty work in country', 'Preventive maintenance', 'Local spares'] },
      ],
    },
    kstar: {
      name: 'Kstar',
      meta: { title: 'Kstar UPS in Angola | UPS Systems 1–30 kVA | EDS Angola', desc: 'Kstar single-phase and three-phase UPS systems from 1 to 30 kVA in Angola — surveyed, supplied, installed and maintained by EDS Angola engineers.' },
      tag: 'UPS systems 1 – 30 kVA',
      intro: 'Kstar is a global UPS manufacturer with particular strength in the 1 to 30 kVA band — the range that covers most racks, edge sites, comms rooms and small facilities in Angola. We survey, supply, install and maintain Kstar systems with the same full-scope approach as every project we take on.',
      image: 'serverOps',
      families: [
        { t: 'Single-phase UPS', d: 'Online double-conversion systems, tower or rack-mount, from 1 to 10 kVA for racks, edge sites and small IT rooms.', items: ['1–3 kVA tower & rack', '6–10 kVA tower & rack', 'Long-backup configurations'] },
        { t: 'Three-phase UPS', d: 'From 10 to 30 kVA for comms rooms and small facilities.', items: ['10–20 kVA', '30 kVA', 'Parallel configurations'] },
        { t: 'Battery plant', d: 'Matched VRLA battery strings and cabinets, engineered for the autonomy your operation requires.', items: ['VRLA battery strings', 'Battery cabinets', 'Autonomy engineering'] },
        { t: 'Integration', d: 'Installation, commissioning and maintenance carried out by our own engineers.', items: ['Load survey & sizing', 'Installation & commissioning', 'Preventive maintenance'] },
      ],
    },
    fiamm: {
      name: 'Fiamm',
      meta: { title: 'FIAMM Batteries in Angola | Industrial VRLA, Gel & OPzS | EDS Angola', desc: 'FIAMM industrial batteries in Angola — AGM VRLA, front-terminal telecom, OPzV gel and OPzS plant for UPS and standby power, supplied and installed by EDS Angola.' },
      tag: 'Industrial batteries',
      intro: 'FIAMM designs and manufactures industrial batteries in Italy, with ranges engineered specifically for UPS and standby duty — from long-life AGM monoblocs to 20-year tubular gel plant. We size, supply, install and replace FIAMM battery systems on a planned cycle.',
      image: 'circuit',
      families: [
        { t: 'FGL — AGM VRLA', d: 'Long-life AGM VRLA monoblocs for UPS and standby installations, rated Eurobat Long Life.', items: ['AGM VRLA monoblocs', 'UPS & rack installations', '10–12 year design life'] },
        { t: 'FIT — front terminal', d: 'Front-terminal AGM VRLA batteries for 19" and 23" telecom cabinets and racks.', items: ['Front-terminal format', 'Telecom cabinets', 'Very Long Life, 12+ years'] },
        { t: 'SMG — OPzV gel', d: 'Tubular gel (OPzV) cells for deep-cycle, critical-condition duty, with design life up to 20 years.', items: ['Tubular gel OPzV', 'Deep-cycle duty', 'Up to 20-year design life'] },
        { t: 'OPzS & pure lead', d: 'Flooded tubular (OPzS) and pure-lead planté cells for large standby plant.', items: ['Flooded tubular OPzS', 'Pure-lead planté', 'Large standby plant'] },
      ],
    },
    netceed: {
      name: 'Netceed',
      meta: { title: 'Netceed Network Infrastructure in Angola | HFC & FTTH | EDS Angola', desc: 'Netceed HFC and FTTH network infrastructure in Angola — optical systems, nodes, passive infrastructure and connectivity, supplied by EDS Angola.' },
      tag: 'Network infrastructure',
      intro: 'Netceed supplies the active and passive infrastructure behind HFC and FTTH broadband networks — from headend optical systems to last-mile passives and field consumables. We supply and integrate Netceed equipment for telecommunications operators and data centre environments.',
      image: 'fibre',
      families: [
        { t: 'Optical systems', d: '1310/1550 nm transmitters and high-power EDFA amplifiers for DOCSIS 3.1 and 4.0 networks.', items: ['Optical transmitters', 'EDFA amplifiers', 'DOCSIS 3.1 / 4.0 ready'] },
        { t: 'Nodes & receivers', d: 'Optical nodes and micro-nodes, including RFoG variants with GPON/XGS-PON pass-through.', items: ['Optical nodes', 'Micro-nodes & RFoG', 'GPON / XGS-PON pass-through'] },
        { t: 'FTTH passive infrastructure', d: 'ODF systems, splice panels, PLC splitters and modular outdoor cabinets.', items: ['ODF & splice panels', 'PLC splitters', 'Outdoor cabinets'] },
        { t: 'Connectivity & tools', d: 'Coaxial cables, connectors, network passives and field consumables.', items: ['Cables & connectors', 'Network passives', 'Field tools & consumables'] },
      ],
    },
    leoch: {
      name: 'Leoch',
      meta: { title: 'Leoch Batteries in Angola | VRLA, Gel & Lithium | EDS Angola', desc: 'Leoch battery technology in Angola — AGM VRLA, gel, OPzV tubular and LiFePO4 lithium for critical backup power, supplied and installed by EDS Angola.' },
      tag: 'Battery technology',
      intro: 'Leoch is one of the world\u2019s largest battery manufacturers, covering every mainstream standby technology — AGM VRLA, gel, tubular and lithium iron phosphate. We engineer Leoch battery plant for the autonomy your operation requires, and replace it on a planned cycle rather than on failure.',
      image: 'solar',
      families: [
        { t: 'AGM VRLA', d: 'General-purpose and UPS-rated AGM monoblocs across a wide capacity range.', items: ['UPS-rated monoblocs', 'Standby duty', 'Wide capacity range'] },
        { t: 'Gel & tubular', d: 'Gel and OPzV tubular ranges for deep-cycle and long-life standby duty.', items: ['Gel monoblocs', 'OPzV tubular', 'Deep-cycle duty'] },
        { t: 'Lithium LiFePO4', d: 'Lithium iron phosphate modules with integrated BMS for high cycle life.', items: ['LiFePO4 modules', 'Integrated BMS', 'High cycle life'] },
        { t: 'Telecom & front terminal', d: 'Front-terminal series for cabinets and telecommunications sites.', items: ['Front-terminal format', 'Telecom sites', 'Outdoor enclosures'] },
      ],
    },
  },
  contact: {
    hero: {
      overline: 'Contact',
      lines: ['Tell us what', 'you need to protect.'],
      sub: 'Tell us the load, the site or the problem. We respond with a site visit, a load survey or a budget proposal — not a brochure.',
    },
    form: {
      overline: 'Send an enquiry',
      name: 'Name', company: 'Company', sector: 'Sector', phone: 'Phone',
      message: 'The load, the site, or the problem',
      submit: 'Send enquiry', sending: 'Sending…',
      successTitle: 'Enquiry received.',
      successBody: 'Thank you. Our team will come back to you with a site visit, a load survey or a budget proposal.',
      errorBody: 'Something went wrong sending your enquiry. Please email us directly at info@edsangola.org.',
      sectors: ['Government & public institutions', 'Banking & financial services', 'Telecommunications', 'Data centre', 'Healthcare', 'Industry & manufacturing', 'Construction & contracting', 'Commercial & residential', 'Other'],
    },
    direct: { overline: 'Direct', angolaTitle: 'EDS Angola — Engineering & Data Solutions' },
    group: { overline: 'Group offices' },
  },
  footer: {
    tagline: 'Turnkey critical power, data centre and electrical engineering — under one contract, in Angola.',
    navTitle: 'Site', contactTitle: 'Luanda HQ', groupTitle: 'Group offices',
    vertiv: 'Vertiv Diamond Partner for Angola — Authorised Partner & certified Service Provider.',
    rights: 'All rights reserved.',
    groupOffices: [
      { country: 'Lebanon', name: 'Engineering Solutions & Services S.A.L', detail: 'Gardenia 3 Bldg, Hazmieh Street, Beirut' },
      { country: 'Iraq', name: 'OFOQ for General Trading and Contracting LLC', detail: 'Baghdad' },
      { country: 'Nigeria', name: 'ESS Nigeria', detail: '24 Adeola Odeku, LSDPC Buildings, VI, Lagos' },
    ],
  },
};
